import React from 'react'
import CategoriesList from '../categories/CategoriesList'

interface IAllowedCategoriesProps {
    setAllowedCategories: (categories: number[]) => void,
    allowedCategories: number[]
}

export default function AllowedCategories(props: IAllowedCategoriesProps) {

    const {
        setAllowedCategories,
        allowedCategories,
    } = props

    return(
        <div className="allowed-categories-container">
            <div className="content-of-allowed-categories-container">

                <p className="allowed-categories-title">Allowed categoeries to request</p>

                <CategoriesList
                    enableSelectCategory={true}
                    disableAddNew={true}
                    checkedCategories={allowedCategories}
                    updateCheckedCategories={setAllowedCategories}
                    loadAll={true}
                />
                
            </div>
        </div>
    )
}